import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import ReactGA from "react-ga4";
import {
  CONSTANTS,
  VERTICALS,
  SOCIAL_PERPAGE_LIMIT,
  COOKIE,
  DATE_FORMATS,
  REGIONAL_LANGUAGE,
} from "../../../../constants/app-constant";
import { httpGet, httpPost } from "../../../../utility/requestHelper";
import SocialFilters from "../../Filters/SocialFilter";
import {
  getDateFormat,
  getUniqueValuesFromList,
  filterListFromAnotherList,
} from "../../../../utility/common-methods.jsx";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import DateRangeFilter from "../../Filters/DateRangeFilter";
import {
  FilterIcon,
  PlusIcon,
  MenuIcon,
  DownLoadSuccess,
} from "../../../Icons/icons.component.jsx";
import ConceptLogo from "../../../../assets/images/conceptbiu-logo.png";
import ArticleTags from "../ArticleTags";
import DownloadFeeds from "../DownloadFeeds";
import { useSelector } from "react-redux";
import TopicWiseNewsContainer from "../PrintAndOnline/TopicWiseNewsContainer";
import Loader from "../../../Shared/Loader";
import NoDataMessage from "../../../Shared/NoDataMessage";
import "../../Analysis/print.sass";
import { SOCIAL_SOURCES_OPTIONS } from "../../../../constants/static-filter";
import { TagsListModal } from "../../TagsAndFavourites/Tags/TagsListModal";
import SocialDownload from "../../../Shared/SocialDownload";
import { getCookie, setCookie } from "../../../../utility/cookieProvider";
import styles from "../../Download.module.css";
import DownloadPopup from "../../DownloadPopup";
import GifLoader from "../../../Shared/LoaderGif";
import { feedCountInArray } from "../BlogAndForum/utils/feedCountInArray";
import ShareArticle from "../../../Shared/ShareArticle";
import {GACODE} from "../../../../constants/app-constant";

const { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } = CONSTANTS;
const today = new Date();
const defaultValues = {
  def_fromDate: getDateFormat(today),
  def_toDate: getDateFormat(today),
  def_channelType: EMPTY_ARRAY,
  def_comments_count: 0,
  def_reaction_count: 0,
  def_city: EMPTY_STRING,
  def_tonality: EMPTY_ARRAY,
};

const {
  def_toDate,
  def_fromDate,
  def_reaction_count,
  def_tonality,
  def_channelType,
  def_city,
  def_comments_count,
} = defaultValues;

function SocialNews({ data }) {
  ReactGA.initialize(GACODE);

  const listContainerRef = useRef(null);
  const IsSocialFlag =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.configuration
    ) || {};
  const [limit, setLimit] = useState(1);
  const [totalFeedCount, setTotalFeedCount] = useState(null);
  const [socialFeedList, setSocialFeedList] = useState(EMPTY_ARRAY);
  const [selectedEntity, setselectedEntity] = useState(EMPTY_ARRAY);
  const [hideShowMore, setHideShowMore] = useState(false);
  const [sharePayload, setSharePayload] = useState({});
  const [topicData, setSocialTopicData] = useState({
    pagination: {
      pages: 1,
      data: EMPTY_ARRAY,
      total: 0,
    },
  });

  const [language, setLanguage] = useState(IsSocialFlag?.configuration?.language_metadata?(IsSocialFlag?.configuration?.language_metadata?.split(",")):Object.keys(REGIONAL_LANGUAGE));
  const [country, setCountry] = useState([]);
  const [dateRange, setdateRange] = useState([moment().startOf("day").format(DATE_FORMATS.DTS_MMYYYYDD_dash),moment().endOf("day").format(DATE_FORMATS.DTS_MMYYYYDD_dash)]);
  const [fromDate, setFromDate] = useState(moment().startOf("day").format(DATE_FORMATS.DTS_MMYYYYDD_dash));
  const [toDate, setToDate] = useState(moment().endOf("day").format(DATE_FORMATS.DTS_MMYYYYDD_dash));
  console.log("SOCIAL_SOURCES_OPTIONS", SOCIAL_SOURCES_OPTIONS);
  const [channelType, setChannelType] = useState(
    SOCIAL_SOURCES_OPTIONS.map(({ id }) => id)
  );
  const [comments, setComments] = useState(def_comments_count);
  const [city, setCity] = useState(EMPTY_OBJECT);
  const [selectCity, setSelectedCity] = useState(def_city);
  const [reaction, setReaction] = useState(def_reaction_count);
  const [tonality, setTonality] = useState(def_tonality);
  const [isLoading, setIsLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedTaglist, setSelectedTaglist] = useState([]);
  const [activeKey, setActiveKey] = useState(-1);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedsGroup, setSelectedFeedsGroup] = useState([]);
  const [showNoTopicsMessage, setShowNoTopicMessage] = useState(false);
  const [isWidgetInit, setIsWidgetInit] = useState(false);
  const [updatedBulkSentiment, setUpdatedBulkSentiment] = useState("");
  const [headline, setHeadline] = useState("");
  const [keyword, setKeyword] = useState("");
  const [updatedBulkFavourite, setUpdatedBulkFavourite] = useState(false);
  const [showAddTagListModal, setShowAddTagListModal] = useState(false);
  const [isFavouriteChecked, setIsFavouriteChecked] = useState(false);
  const [popup, setPopup] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isAllLoad, setAllIsLoad] = useState(false);
  const [isTMLAllLoad, setTMLAllIsLoad] = useState(false);

  const [countFilters, setCountFilters] = useState({
    likesCount: 0,
    commentsCount: 0,
    shareOrRetweetCount: 0,
    // TODO: to be done as part of CB-476
    // viewsCount: 0,
    // dislikeCount: 0,
  });
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [showInfluencerPosts, setShowInfluencerPosts] = useState(false);
  let [isMainstreammedia, setMainstreammediaChecked] = useState("XX");
  const [tagListData, setTagListData] = useState([]);
  const isSocialDownloading = getCookie(COOKIE.IS_SOCIAL_DOWNLOADING);
  const isPrintDownloading = getCookie(COOKIE.IS_PRINT_DOWNLOADING);
  const isBlogDownloading = getCookie(COOKIE.IS_BLOG_DOWNLOADING);
  const DownloadSuccess = getCookie(COOKIE.DOWNLOAD_SUCCESS);
  const [showList, setShowList] = useState(true);
  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );

  // Enable defult mainstreammedia Filteration - start
    const mainstreammedia = localStorage.getItem("mainstreammedia");      
    if(isMainstreammedia == true && isMainstreammedia != 'XX'){
      //console.log("1111");
      isMainstreammedia = true;
    } else if(isMainstreammedia == false && isMainstreammedia != 'XX'){
      //console.log("2222");
      isMainstreammedia = false;
    } else if(mainstreammedia == 0 && isMainstreammedia == 'XX'){
      //console.log("3333");
      isMainstreammedia = false;
    } else if(mainstreammedia == 1 && isMainstreammedia == 'XX'){
      //console.log("4444");
      isMainstreammedia = true;
    }else {
      //console.log("5555");
      isMainstreammedia = false;
    }

  // End  

  const { socialEntityList } = entityState || [];
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const clientState = useSelector((state) => state.clientReducer) || {};
  const { feedTagList } = clientState;
  const parentClientId = useSelector(
    (state) => state.entityAndKeyWordsReducer.parentClientId
  );

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.set({ userId: selectedClient.id+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClient.id+".0."+concept_uid });
  }
    let locationHrefNew = window.location.href;
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.event({
      category: "Social",
      action: "Social - "+selectedClient.id+".0."+concept_uid,
      label: locationHrefNew, // optional
      //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
    });
  }
  // useEffect(() => {
  //   fetchCity();
  // }, EMPTY_ARRAY);

  useEffect(() => {
    if (selectedTopics && selectedTopics.length && !isWidgetInit) {
      fetchSocialFeedsFilterData(false);
      setIsWidgetInit(true);
    }
  }, [selectedTopics, parentClientId]);

  useEffect(() => {
    if (isWidgetInit) {
      fetchSocialFeedsFilterData(limit !== 1);
    }
  }, [limit, dateRange]);
  useEffect(() => {
    if (DownloadSuccess === "true") {
      setPopup(DownloadSuccess === "true");
    }
    setTimeout(() => {
      setCookie({
        key: COOKIE.DOWNLOAD_SUCCESS,
        value: false,
      });
      setPopup(false);
    }, 5000);
  }, [DownloadSuccess]);

  useEffect(() => {
    if (topicData && topicData.pagination && topicData.pagination.total) {
      setHideShowMore(topicData.pagination.total === socialFeedList.length);
    }
  }, [socialFeedList.length]);

  useEffect(() => {
    if (socialEntityList) {
      const entIdList = socialEntityList.map((e) => e && e.id);
      setSelectedTopics(entIdList);
    }
    setShowNoTopicMessage(!socialEntityList);
    if (feedTagList) {
      const { data } = feedTagList;
      // const tagIds = data.map((e) => e.name);
      // setSelectedTaglist(tagIds);
      data.forEach((item, i) => {
        if (item.name === "Not Rated") {
          data.splice(i, 1);
          data.unshift(item);
        }
      });
      setTagListData(data);
    }
    setShowNoTopicMessage(!feedTagList);
  }, [socialEntityList, feedTagList]);

  useEffect(() => {
    if (updatedBulkSentiment) {
      setTimeout(() => {
        resetSelectedFeeds();
      }, 100);
    }
  }, [updatedBulkSentiment, updatedBulkFavourite]);

  useEffect(() => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  }, [updatedBulkFavourite]);

  const handleResetAll = () => {
    setSelectedCity(def_city);
    setReaction(def_reaction_count);
    setComments(def_comments_count);
    setTonality(def_tonality);
    // setToDate(def_toDate);
    // setFromDate(def_fromDate);
    setdateRange([moment().startOf("day").format(DATE_FORMATS.DTS_MMYYYYDD_dash),moment().endOf("day").format(DATE_FORMATS.DTS_MMYYYYDD_dash)])
    setChannelType(def_channelType);
    setSelectedTopics([]);
    setIsFavouriteChecked(false);
    fetchSocialFeedsFilterData(false);
    setShowFilter(false);
  };

  const fetchCity = () => {
    const topicId = data ? data.id : "";

    httpGet(
      `${unifiedEnvConfig.FETCH_CITY}?searchParams[topic_id]=${topicId}&client_id=${selectedClient.id}`
    )
      .then((response) => {
        if (response.data) {
          setCity(response.data);
        }
      })
      .catch((e) => e);
  };

  const getFeedSearchUrl = (selectedTopicIds = [], urlType = "") => {
    const sDate = dateRange[0];
    const eDate = dateRange[1];
    const topicId = selectedTopics;
    let client_id = selectedClient && selectedClient.id;

    //if current client is a child of another client, feed api needs parent id to give data
    if (client_id !== parentClientId) client_id = parentClientId;

    const {
      likesCount,
      dislikeCount,
      commentsCount,
      shareOrRetweetCount,
      viewsCount,
    } = countFilters;
    let url = "";
    switch (urlType) {
      case "favourite":
        url = unifiedEnvConfig.UPDATE_FAVOURITES_TAG;
        break;
      case "sentiment":
        url = unifiedEnvConfig.SOCIAL_UPDATE_SENTIMENTS;
        break;
      case "tags":
        url = unifiedEnvConfig.ADD_TAG_TO_FEED;
        break;
      case "download":
        url = unifiedEnvConfig.FEEDS_DOWNLOAD;
        break;
      case "olddownload":
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS;
        break;
      case "tmldownload":
          url = unifiedEnvConfig.DOWNLOAD_TML;
          break; 
      case "newcount":
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS_COUNT;
        break;
      default:
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS_COUNT_NEW;
        break;
    }
    let tempUrl = `${url}?client_id=${client_id}&page=${limit}&perPage=${SOCIAL_PERPAGE_LIMIT}&searchParams[from_date]=${sDate}&searchParams[to_date]=${eDate}&searchParams[type]=${VERTICALS.V_SOCIAL}&profileAssociate=true`;
    if (isFavouriteChecked) {
      tempUrl = `${tempUrl}&favFilter=${isFavouriteChecked}`;
    }
    if (selectedTaglist && selectedTaglist.length) {
      selectedTaglist.forEach((t) => {
        tempUrl = `${tempUrl}&tagFilter[]=${t === "Not Rated" ? null : t}`;
      });
    }
    if (headline) {
      tempUrl = `${tempUrl}&headlineFilter=${headline}`;
    }
    if (keyword) {
      tempUrl = `${tempUrl}&keywordFilter=${keyword}`;
    }

    if (Array.isArray(channelType)) {
      channelType.forEach((cType) => {
        tempUrl = `${tempUrl}${
          !urlType
            ? "&searchParams[channel_type][]"
            : "&searchParams[channel_type]"
        }=${cType}`;
      });
    }
    if (tonality && tonality.length) {
      tempUrl = `${tempUrl}&tonalityFilter[]=${tonality}`;
    }
    if (Array.isArray(language) && language.length) {
      language.forEach((tLang) => {
        tempUrl = `${tempUrl}&searchParams[lang][]=${tLang}`;
      })
    }
    else if (language && language.length) {
      tempUrl = `${tempUrl}&searchParams[lang]=${language}`;
    }
    if (Array.isArray(country) && country.length) {
      
      country.forEach((tcutry) => {
        //console.log("tcutry:",tcutry);
        tempUrl = `${tempUrl}&searchParams[country][]=${tcutry}`;
      })
    }
    else if (country && country.length) {
      
      tempUrl = `${tempUrl}&searchParams[country]=${country}`;
    }
    if (selectCity && selectCity.length) {
      tempUrl = `${tempUrl}&searchParams[city]=${selectCity}`;
    }
    if (commentsCount) {
      tempUrl = `${tempUrl}&searchParams[min_comments]=${commentsCount}`;
    }
    if (likesCount) {
      tempUrl = `${tempUrl}&searchParams[min_likes]=${likesCount}`;
    }
    if (shareOrRetweetCount) {
      tempUrl = `${tempUrl}&searchParams[min_shares]=${shareOrRetweetCount}`;
    }
    if (showInfluencerPosts) {
      tempUrl = `${tempUrl}&searchParams[influencer_filter]=${true}`;
    }

    //console.log("11111 XXXXXXXXXisMainstreammedia:",isMainstreammedia);

    if (isMainstreammedia) {
      tempUrl = `${tempUrl}&searchParams[mainstreammedia]=1`;
    } 

    // else {
    //   const mainstreammedia = localStorage.getItem("mainstreammedia");
    //   console.log("XXXXXmainstreammedia:",mainstreammedia);
    //   if(mainstreammedia == 1){
    //     tempUrl = `${tempUrl}&searchParams[mainstreammedia]=1`;
    //   }
    // }

    if (urlType !== "download") {
      if (selectedTopicIds.length > 0) {
        [...new Set(selectedTopicIds)].forEach((t) => {
          tempUrl = `${tempUrl}${
            !urlType ? "&searchParams[topic_ids][]" : "&searchParams[topic_id]"
          }=${t}`;
        });
      } else {
        topicId.forEach((t) => {
          tempUrl = `${tempUrl}&searchParams[topic_ids][]=${t}`;
        });
      }
    }
    // TODO: to be done as part of CB-476
    // if (dislikeCount) {
    //   tempUrl = `${tempUrl}&searchParams[min_shares]=${dislikeCount}`;
    // }
    // if (viewsCount) {
    //   tempUrl = `${tempUrl}&searchParams[min_views]=${viewsCount}`;
    // }
    // if (reaction && reaction.length) {
    //   tempUrl = `${tempUrl}&searchParams[min_reactions]=${reaction}`;
    // }
    return tempUrl;
  };
  const soicalFeedUrlPayload = (selectedTopicIds = [], urlType = "") => {
    const sDate = dateRange[0];
    const eDate = dateRange[1];
    const topicId = selectedTopics;
    let client_id = selectedClient && selectedClient.id;

    //if current client is a child of another client, feed api needs parent id to give data
    if (client_id !== parentClientId) client_id = parentClientId;

    const {
      likesCount,
      dislikeCount,
      commentsCount,
      shareOrRetweetCount,
      viewsCount,
    } = countFilters;
    let url = "";
    switch (urlType) {
      case "favourite":
        url = unifiedEnvConfig.UPDATE_FAVOURITES_TAG;
        break;
      case "sentiment":
        url = unifiedEnvConfig.SOCIAL_UPDATE_SENTIMENTS;
        break;
      case "tags":
        url = unifiedEnvConfig.ADD_TAG_TO_FEED;
        break;
      case "download":
        url = unifiedEnvConfig.FEEDS_DOWNLOAD;
        break;
      case "olddownload":
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS;
        break;
      case "tmldownload":
          url = unifiedEnvConfig.DOWNLOAD_TML;
          break;
      case "newcount":
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS_COUNT;
        break;
      default:
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS_COUNT_NEW;
        break;
    }
    let payload = {
      client_id: client_id,
      page: limit,
      perPage: SOCIAL_PERPAGE_LIMIT,
    };
    let searchParams = {
      to_date: eDate,
      type: VERTICALS.V_SOCIAL,
      from_date: sDate,
    };

    if (isFavouriteChecked) {
      payload.favFilter = isFavouriteChecked;
    }
    if (selectedTaglist && selectedTaglist.length) {
      payload.tagFilter = [];
      selectedTaglist.forEach((t) => {
        payload.tagFilter.push(t === "Not Rated" ? null : t);
      });
    }
    if (headline) {
      payload.headlineFilter = headline;
    }
    if (keyword) {
      payload.keywordFilter = keyword;
    }

    if (Array.isArray(channelType)) {
      searchParams.channel_type = [];
      channelType.forEach((cType) => {
        searchParams.channel_type.push(cType);
      });
    }
    if (tonality && tonality.length) {
      payload.tonalityFilter = tonality;
    }
    if (language && language.length) {
      searchParams.lang = language;
    }
    if (language && language.length) {
      searchParams.country = country;
    }
    if (selectCity && selectCity.length) {
      searchParams.city = selectCity;
    }
    if (commentsCount) {
      searchParams.min_comments = commentsCount;
    }
    if (likesCount) {
      searchParams.min_likes = likesCount;
    }
    if (shareOrRetweetCount) {
      searchParams.min_shares = shareOrRetweetCount;
    }
    if (showInfluencerPosts) {
      searchParams.influencer_filter = true;
    }

    //console.log("22222 XXXXXXXXX isMainstreammedia:",isMainstreammedia);
    
    if (isMainstreammedia) {
      searchParams.mainstreammedia = "1";
    } 
    // else {
    //   const mainstreammedia = localStorage.getItem("mainstreammedia");
    //   console.log("XXXXXmainstreammedia:",mainstreammedia);
    //   if(mainstreammedia == 1){
    //     searchParams.mainstreammedia = "1";
    //   }
    // }

    if (urlType !== "download") {
      searchParams.topic_ids = [];
      if (selectedTopicIds.length > 0) {
        [...new Set(selectedTopicIds)].forEach((t) => {
          !urlType
            ? (searchParams.topic_ids = [])
            : (searchParams.topic_id = t);
        });
      } else {
        topicId.forEach((t) => {
          searchParams.topic_ids.push(t);
        });
      }
    }
    payload.searchParams = searchParams;

    setSharePayload(payload);

    return { url: url, payload: payload };
  };

  const fetchSocialFeedsFilterData = (preserveData, filter) => {
    if (selectedTopics.length) {
      setIsLoading(true);
      const inputData = soicalFeedUrlPayload(
        [],
        filter === true ? "newcount" : ""
      );
      setActiveKey(-1)
      httpPost(inputData.url, inputData.payload)
        .then(({ data }) => {
          if (data) {
            setSocialTopicData(data);

            setSocialTopicData(data);
            let allFeeds = [...data.data.topics];
            allFeeds = allFeeds.filter((elm) => elm.count !== 0 && elm);
            if (preserveData) {
              allFeeds = [...socialFeedList, allFeeds].flat();
            }
            const feedCount = feedCountInArray(
              data.data.topics,
              selectedTopics
            );
            setTotalFeedCount(feedCount);
            // if (allFeeds && allFeeds.length) {
            //   setTotalFeedCount(
            //     (prevVal) =>
            //       allFeeds.reduce(
            //         (prevEle, currentEle) => ({
            //           total: prevEle.total + currentEle.total,
            //         }),
            //         { total: 0 }
            //       ).total
            //   );
            // }

            // display feeds topics included in selected topics.
            const feedsToDisplay = allFeeds.filter((val) =>
              selectedTopics.includes(val.topic.id)
            );

            setSocialFeedList(feedsToDisplay);
            // let allFeeds = [...data.data];
            // allFeeds = allFeeds.filter(
            //   (elm) => elm.feeds && elm.feeds.length && elm
            // );
            // if (preserveData) {
            //   allFeeds = [...socialFeedList, allFeeds].flat();
            // }
            // if (allFeeds && allFeeds.length) {
            //   setTotalFeedCount(
            //     (prevVal) =>
            //       allFeeds.reduce(
            //         (prevEle, currentEle) => ({
            //           total: prevEle.total + currentEle.total,
            //         }),
            //         { total: 0 }
            //       ).total
            //   );
            // }
            // setSocialFeedList(allFeeds);
            // eslint-disable-next-line
            if (limit == 1) {
              window.scrollTo(0, 0);
            }
          }
        })
        .catch((e) => {
          console.log("[Error in Social feeds search]: ", e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const onFilterApply = (e, customParams) => {
    // TODO: should be handled in better way.
    // Resetting limit state to trigger useEffect.
    if (customParams) {
      // setToDate(customParams.endDate);
      // setFromDate(customParams.startDate);
      setdateRange([customParams.startDate,customParams.endDate])
    } else {
      fetchSocialFeedsFilterData(false, true);
    }
    setSelectedFeedsGroup([]);
    setSelectedFeeds([]);
  };

  const handleFilterSelect = (name, value) => {
    const { start, end } = value || {};
    // setFromDate(getDateFormat(start));
    // setToDate(getDateFormat(end));
    setdateRange([getDateFormat(start),getDateFormat(end)])
  };

  const handleDateChange = (date, type) => {
    setdateRange([moment(date.from).format(DATE_FORMATS.DTS_MMYYYYDD_dash),moment(date.to).format(DATE_FORMATS.DTS_MMYYYYDD_dash)])
    // const formattedDate = moment(date).format(DATE_FORMATS.DTS_MMYYYYDD_dash);
    // if (type === "start") {
    //   setFromDate(formattedDate);
    // } else {
    //   setToDate(formattedDate);
    // }
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  };

  const mergePaginatedFeedsToCurrentList = (allFeeds, entityId) => {
    let modifiedList = [];
    socialFeedList.forEach((item) => {
      if (item.topic.id == entityId) {
        item.feeds = allFeeds;
      }
      modifiedList.push(item);
    });
    setSocialFeedList(modifiedList);
    isSelectAll && handleSelectedFeeds(isSelectAll, modifiedList, entityId);
  };

  const handleSelectedFeeds = (selected, feedlist, entityId, entityName) => {
    let tempFeedsToShare = {};
    const currentSelectedFeedObject = socialFeedList.find(
      (item) => item.topic && item.topic.id == entityId
    );
    if (selected) {
      let tArr=[...selectedEntity]
      tArr.push(entityId)
      setselectedEntity(tArr)
      if (!Array.isArray(currentSelectedFeedObject.feeds)) {
        tempFeedsToShare = [{ ...feedlist, topic_name: entityName }];
      } else {
        tempFeedsToShare = currentSelectedFeedObject.feeds.map((elm) => ({
          ...elm,
          topic_name: entityName,
          topicName: elm.page_details && elm.page_details.name,
          isBulkUpdate: selected,
        }));
      }
      setSelectedFeeds([...selectedFeeds, ...tempFeedsToShare]);
    } else {
      let tArr=[...selectedEntity]
      setselectedEntity(tArr.filter(data => data !== entityId))
      if (!Array.isArray(feedlist)) {
        setSelectedFeeds(selectedFeeds.filter((n) => n.id != feedlist.id));
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.id !== element.id) return n;
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const onSingleFeedSelect = (selected, feedlist, entityId) => {
    let tempFeedsToShare = {};
    if (selected) {
      if (!Array.isArray(feedlist)) {
        tempFeedsToShare = [feedlist];
      } else {
        tempFeedsToShare = feedlist.map((elm) => {
          return {
            ...elm,
            topic_name: elm.topic_name,
            topicName: elm.page_details && elm.page_details.name,
            isBulkUpdate: selected,
          };
        });
      }
      setSelectedFeeds([...selectedFeeds, ...tempFeedsToShare]);
    } else {
      if (!Array.isArray(feedlist)) {
        setSelectedFeeds(selectedFeeds.filter((n) => n.id != feedlist.id));
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.id !== element.id) return n;
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const handleFeedGroupClick = (groupIdentifier) => {
    if (selectedFeedsGroup.indexOf(groupIdentifier) !== -1) {
      setSelectedFeedsGroup(
        selectedFeedsGroup.filter((g) => g !== groupIdentifier)
      );
    } else {
      setSelectedFeedsGroup([...selectedFeedsGroup, groupIdentifier]);
    }
  };

  const handleBulkUpdateSuccess = (
    bulkUpdatedSentiment,
    bulkUpdatedFavourite = undefined
  ) => {
    if (!bulkUpdatedSentiment && bulkUpdatedFavourite == undefined) {
      return;
    }
    setUpdatedBulkSentiment(bulkUpdatedSentiment);

    if (bulkUpdatedFavourite != undefined) {
      setUpdatedBulkFavourite(bulkUpdatedFavourite);
    }
  };

  const formatTagsForBulkUpdate = (tagList, selectedFeedsList) => {
    let updateByFilter = false;
    let tempFeedArray = [];
    selectedFeedsList.forEach((item) => {
      if (item.isBulkUpdate) {
        updateByFilter = item.isBulkUpdate;
      }
      tempFeedArray.push({
        social_feed_id: item.id,
        channel_type: item.channel_type,
      });
    });
    return {
      updateByFilter,
      tag_ids: tagList.map((i) => i.id),
      feeds: tempFeedArray,
    };
  };

  const handleTagsBulkUpdate = (selectedTags) => {
    const entityIdList = [...new Set(selectedFeeds.map((i) => i.entityId))];
    let promiseList = [];
    entityIdList.forEach((entity) => {
      const payload = formatTagsForBulkUpdate(selectedTags, selectedFeeds);
      promiseList = [
        ...promiseList,
        httpPost(getFeedSearchUrl([entity], "tags"), payload),
      ];
    });
    return Promise.allSettled(promiseList)
      .then((res) => {
        setSelectedFeeds([]);
        setSelectedFeedsGroup([]);
        updateSelectedTagsToFeeds(
          selectedTags.map((item) => {
            return {
              tag_id: item.tag_id || item.id,
              tag_name: item.name,
            };
          })
        );
        setShowAddTagListModal(false);
      })
      .catch((err) => {
        console.log(err);
        alert("Couldn't add tags");
      });
  };

  const updateSelectedTagsToFeeds = (
    selectedTags,
    removeTagFromList = false,
    entityId,
    feedId
  ) => {
    let modifiedFeeds = [];
    socialFeedList.forEach((feed) => {
      if (removeTagFromList) {
        if (feed.topic.id == entityId) {
          feed.feeds.forEach((feedItem) => {
            if (feedItem.id == feedId) {
              feedItem.tags = filterListFromAnotherList(
                feedItem.tags,
                selectedTags,
                "tag_id"
              );
            }
          });
        }
      } else {
        selectedFeeds.forEach((item) => {
          if (feed.topic.id == item.entityId) {
            feed.feeds.forEach((feedItem) => {
              if (item.id == feedItem.id) {
                feedItem.tags = getUniqueValuesFromList(
                  [...feedItem.tags, ...selectedTags],
                  "tag_id"
                );
              }
            });
          }
        });
      }
      modifiedFeeds.push(feed);
    });
    setSocialFeedList(modifiedFeeds);
  };

  const resetSelectedFeeds = () => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  };

  const showLoader = isLoading;
  const showNoDataMessage = !showLoader && !socialFeedList.length;
  const showData = !showLoader && !showNoDataMessage;
  const progressPopup = (open) => {
    setShowList(open);
  };
  const isDownloading =
    isPrintDownloading == "true" ||
    isSocialDownloading == "true" ||
    isBlogDownloading == "true";
  return (
    <>
      {showAddTagListModal ? (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          onBulkUpdate={handleTagsBulkUpdate}
        />
      ) : null}
      <div
        className={
          !!selectedFeeds.length
            ? "mainContainer socialContainer feedsSelected"
            : "mainContainer socialContainer"
        }
      >
        {showLoader && <GifLoader />}
        <div className="dashboardHeader dashboardHeading">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <h1>Social</h1>
              </div>
              {popup && (
                <div className={styles.downloadLabel}>
                  <DownLoadSuccess />
                  <h3>Report download completed successfully !</h3>
                </div>
              )}
            </div>
          </div>
          <div className="topFilterWrap">
            <div className="mobTopHeading">
              <h1>Social</h1>
            </div>
            <div className="titleRow socialTitleRow" style={{marginBottom:0}}>
              <div className="titleLeftWrap">
                <div className="filterWrap">
                  <DateRangeFilter
                    key="social-feed"
                    startRange={dateRange[0]}
                    endRange={dateRange[1]}
                    isSocial
                    handleDateChange={handleDateChange}
                    showShortCut
                    minDate={selectedClient ? selectedClient.start_date : null}
                    maxDate={selectedClient ? selectedClient.end_date : null}
                  />
                  {/* <DateRangeFilter /> */}
                  <div className="downloadBtnWithText singleDownloadBtn">
                    <SocialDownload
                      articles={selectedFeeds}
                      downloadUrl={getFeedSearchUrl([], "olddownload")}
                      client_id={selectedClient.id}
                      onSuccessCallback={resetSelectedFeeds}
                      totalFeedCount={totalFeedCount}
                      setIsLoading={setIsLoad}
                      isLoading={isLoad}
                      isSocial
                    />
                  </div>
                  <button
                    onClick={() => setShowFilter(true)}
                    className="btn filterBtn"
                  >
                    <FilterIcon /> <span>Filters</span>
                  </button>
                </div>
              </div>
              <div className="rightBtnContainer">
                {!!selectedFeeds.length && (
                  <button className="btn optionBtn">
                    <div className="hasTooltip">
                      <ShareArticle
                        client_id={selectedClient.id}
                        article={selectedFeeds}
                        isSocial={true}
                        sharePayload={sharePayload}
                        selectedTopicIds={selectedTopics}
                        fromDate={dateRange[0]}
                        toDate={dateRange[1]}
                        channelType={channelType}
                        selectedEntity={selectedEntity}
                        language={language}
                      />
                      <span className="tooltipWrap center">Share</span>
                    </div>
                  </button>
                )}
                <ul className="dropDownContainer">
                  {selectedFeeds && !!selectedFeeds.length && (
                    <ArticleTags
                      article={selectedFeeds}
                      forBulkUpdate
                      getFeedSearchUrl={getFeedSearchUrl}
                      hideTheme
                      isSocial
                      onSuccessCallback={handleBulkUpdateSuccess}
                      setUpdatedBulkFavourite={setUpdatedBulkFavourite}
                      setUpdatedBulkSentiment={setUpdatedBulkSentiment}
                      showFavouriteTag
                      singleNewsGroup={selectedFeeds}
                    />
                  )}
                  {selectedFeeds && !!selectedFeeds.length && (
                    <button
                      className="btn addTagBtn"
                      onClick={() => setShowAddTagListModal(true)}
                    >
                      <PlusIcon /> Add Tag
                    </button>
                  )}
                  <div className="downloadBtnWithText singleDownloadBtn">
                    <SocialDownload
                      articles={selectedFeeds}
                      downloadUrl={getFeedSearchUrl([], "olddownload")}
                      client_id={selectedClient.id}
                      onSuccessCallback={resetSelectedFeeds}
                      totalFeedCount={totalFeedCount}
                      setIsLoading={setIsLoad}
                      isLoading={isLoad}
                      isSocial
                      downloadList={[
                        selectedFeeds.length  > 0 ? {
                          label: "Download Selected",
                          downloadUrl: getFeedSearchUrl([], "olddownload"),
                          isDownloadAll: false
                        } : {},
                        {
                          label: "Download All",
                          downloadUrl: getFeedSearchUrl([], "olddownload"),
                          isDownloadAll: true
                        },
                        selectedClient.id === '4811' ? {
                          label: "DownLoad TML Channel",
                          downloadUrl: getFeedSearchUrl([], "tmldownload"),
                          isDownloadAll: true
                        } : {},
                      ]}
                    />
                    {/* <SocialDownload
                      articles={selectedFeeds}
                      downloadUrl={getFeedSearchUrl([], "olddownload")}
                      onSuccessCallback={resetSelectedFeeds}
                      totalFeedCount={totalFeedCount}
                      setIsLoading={setAllIsLoad}
                      isLoading={isAllLoad}
                      isSocial
                      isDownloadAll={true}
                    />
                    {selectedClient.id === '4811' &&
                    <SocialDownload
                      articles={selectedFeeds}
                      downloadUrl={getFeedSearchUrl([], "tmldownload")}
                      onSuccessCallback={resetSelectedFeeds}
                      totalFeedCount={totalFeedCount}
                      setIsLoading={setTMLAllIsLoad}
                      isLoading={isTMLAllLoad}
                      isSocial
                      isDownloadAll={true}
                      isTml={true}
                    />
} */}
                  </div>
                  {isDownloading && !isLoad && !isAllLoad && (
                    <div className={styles.DownloadPopup_downloadList__3zmI8}>
                      <DownloadPopup
                        IsPrintAndOnline={isPrintDownloading === "true"}
                        clicked={progressPopup}
                        showList={showList}
                        IsBlogAndForum={isBlogDownloading === "true"}
                        isSocial={isSocialDownloading === "true"}
                      />
                    </div>
                  )}
                  <button
                    onClick={() => setShowFilter(true)}
                    className="btn filterBtn"
                  >
                    <FilterIcon /> <span>Filters</span>
                  </button>
                </ul>
                <div
                  className={`filtersWrap sideFilterWrap ${
                    !showFilter ? "hide" : "show"
                  }`}
                >
                  <div className="filtersColumnWrap">
                    {/* <Filters /> */}
                    <SocialFilters
                      language={language}
                      setLanguage={setLanguage}
                      country={country}
                      setCountry={setCountry}
                      handleFilterSelect={handleFilterSelect}
                      fetchSocialFeeds={onFilterApply}
                      cityData={city}
                      setTonality={setTonality}
                      fromDate={dateRange[0]}
                      toDate={dateRange[1]}
                      tonality={tonality}
                      detailsField={false}
                      selectCity={selectCity}
                      setSelectedCity={setSelectedCity}
                      comments={comments}
                      setComments={setComments}
                      channelType={channelType}
                      setChannelType={setChannelType}
                      reaction={reaction}
                      setReaction={setReaction}
                      handleResetAll={handleResetAll}
                      setShowFilter={setShowFilter}
                      setSelectedTopics={setSelectedTopics}
                      selectedTopics={selectedTopics}
                      entityList={socialEntityList}
                      setIsFavouriteChecked={setIsFavouriteChecked}
                      isFavouriteChecked={isFavouriteChecked}
                      countFilters={countFilters}
                      setCountFilters={setCountFilters}
                      isSocial
                      showInfluencerPosts={showInfluencerPosts}
                      setShowInfluencerPosts={setShowInfluencerPosts}
                      isMainstreammedia={isMainstreammedia}
                      setMainstreammediaChecked={setMainstreammediaChecked}
                      tagList={tagListData}
                      setSelectedTaglist={setSelectedTaglist}
                      selectedTaglist={selectedTaglist}
                      headline={headline}
                      setHeadline={setHeadline}
                      keyword={keyword}
                      setKeyword={setKeyword}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showData && totalFeedCount && (
          <div
            style={{
              color: "#0036b9",
              marginTop: "5px",
              marginBottom: "5px",
              fontSize: "14px",
            }}
          >
            {dateRange[0] == dateRange[1] && (
              <>
                Total <span className="feed-count-info">{totalFeedCount}</span>{" "}
                articles found on{" "}
                <span className="feed-count-info">
                  {moment(dateRange[0]).format("Do MMMM YYYY")}
                </span>
              </>
            )}
            {dateRange[0] != dateRange[1] && (
              <>
                Total <span className="feed-count-info">{totalFeedCount}</span>{" "}
                articles were found from{" "}
                <span className="feed-count-info">
                  {moment(dateRange[0]).format("Do MMMM YYYY")}
                </span>{" "}
                to{" "}
                <span className="feed-count-info">
                  {moment(dateRange[1]).format("Do MMMM YYYY")}
                </span>
              </>
            )}
          </div>
        )}
        {showData && (
          <div
            ref={listContainerRef}
            className="accordion accordionListWrap socialAccordionWrap"
          >
            {socialFeedList.map((singleFeedGroup, index) => {
              const data = {
                entityName: singleFeedGroup.topic.name,
                entityId: singleFeedGroup.topic.id,
                socialData: [],
                type: VERTICALS.V_SOCIAL,
                total: singleFeedGroup.count,
              };
              // const allArticleList = singleFeedGroup.feeds.map(
              //   (e) =>
              //     `${e.channel_type}/${e.id}?entityName="${singleFeedGroup.topic.name}"`
              // );
              const allArticleList = [];
              return (
                <TopicWiseNewsContainer
                  listContainerRef={listContainerRef}
                  listkey={index + 1}
                  entityFeeds={data}
                  activeKey={activeKey}
                  setActiveKey={setActiveKey}
                  allArticleList={allArticleList}
                  onFeedSelect={handleSelectedFeeds}
                  onSingleFeedSelect={onSingleFeedSelect}
                  selectedFeeds={selectedFeeds}
                  selectedFeedsGroup={selectedFeedsGroup}
                  setSelectedFeedsGroup={setSelectedFeedsGroup}
                  handleFeedGroupClick={handleFeedGroupClick}
                  onSuccessCallback={handleBulkUpdateSuccess}
                  isSocial
                  toDate={dateRange[1]}
                  fromDate={dateRange[0]}
                  updatedBulkSentiment={updatedBulkSentiment}
                  updatedBulkFavourite={updatedBulkFavourite}
                  clientId={parentClientId}
                  updateSelectedTagsToFeeds={updateSelectedTagsToFeeds}
                  mergePaginatedFeedsToCurrentList={
                    mergePaginatedFeedsToCurrentList
                  }
                  socialFilters={{
                    channelType,
                    comments,
                    city,
                    selectCity,
                    reaction,
                    tonality,
                    selectedTopics,
                    isFavouriteChecked,
                    countFilters,
                    selectedTaglist,
                    keyword,
                    headline,
                    language,
                    country,
                    isMainstreammedia,
                  }}
                  setIsSelectAll={setIsSelectAll}
                  showInfluencerPosts={showInfluencerPosts}
                  isMainstreammedia={isMainstreammedia}
                  keyword={keyword}
                  headline={headline}
                />
              );
            })}
          </div>
        )}
        {showNoDataMessage && !showNoTopicsMessage && (
          <NoDataMessage
            text="No Feeds Found"
            subtext="Try adjusting the filters to find what you’re looking for"
          />
        )}
        {showNoTopicsMessage && (
          <NoDataMessage
            text="No Topics Are Added."
            subtext="Try adding new topics."
          />
        )}
      </div>
    </>
  );
}

export default SocialNews;
